export class CustomApiException extends Error {
  exception?: string;
  exceptionType?: string;
  file: string | undefined;
  message: string;

  constructor(model: Partial<CustomApiException> = {}) {
    super();

    this.message = model.message ?? '';
    this.file = model.file;
    this.exceptionType = model.exceptionType;
  }
}
